import { Button, Tabs } from "antd";
import PropTypes from "prop-types";
import React from "react";
import { useEffect } from "react";
import styles from "./_styles.less";
import { useTranslation } from "react-i18next";
import MiniTable from "../../components/mini-table";
import { nivelAcessoSelector } from "../../store/autenticacao";
import { useSelector } from "react-redux";

export default function ModelosTable({ dataSource, loading, miniTableRef, onClick, onSelectedIdsChange, selectedIds, title, fetchModelosPersonalizado, enableRowSelection, singleSelection = false, personalizado, setPersonalizado }) {
  const { t } = useTranslation();
  const fireClick = (usuario) => (typeof onClick === "function" ? onClick(usuario) : undefined);

  const nivelAcesso = useSelector(nivelAcessoSelector);

  const rowSelectionEnabled = enableRowSelection ?? (personalizado || (!personalizado && nivelAcesso !== 5));

  const columns = [
    {
      title: t("Nome"),
      dataIndex: "nome",
      key: "nome",
      width: 250,
      render: (text, record) => {
        const content = text ?? t("(não preenchido)");
        return rowSelectionEnabled ? (
          <Button type="link" onClick={() => fireClick(record)}>
            {content}
          </Button>
        ) : (
          <span style={{ color: "#999" }}>{content}</span>
        );
      },
    },
    {
      title: t("Módulo"),
      dataIndex: "modulo",
      key: "modulo",
      width: 150,
      render: (modulo) => {
        if (!modulo) return "";
        if (modulo.toLowerCase() === "societario") return "Societário";
        if (modulo.toLowerCase() === "compliance") return "Compliance";
        return modulo;
      },
    },

    {
      title: t("Tipo de modelo"),
      dataIndex: "tags",
      key: "tags",
      width: 150,
      render: (tags) =>
        Array.isArray(tags) &&
        tags.length > 0 && (
          <span>
            {tags.slice(0, 3).map((tag, index) => {
              const capitalized = tag?.charAt(0).toUpperCase() + tag?.slice(1);
              return (
                <span key={index}>
                  {capitalized}
                  {index < tags.slice(0, 3).length - 1 ? ", " : ""}
                </span>
              );
            })}
            {tags.length > 3 && <span style={{ color: "#999" }}>...</span>}
          </span>
        ),
    },
    {
      title: t("Descrição"),
      dataIndex: "descricao",
      key: "descricao",
      width: 300,
      ellipsis: true,
      render: (text) => {
        const preview = text?.length > 80 ? text.slice(0, 80) + "..." : text;
        return <span title={text}>{preview || t("(não preenchido)")}</span>;
      },
    },
  ];

  useEffect(() => {
    fetchModelosPersonalizado({ personalizado });
  }, [personalizado]);

  return (
    <div>
      <Tabs className={styles["tabs"]} activeKey={personalizado ? "personalizado" : "padrao"} onChange={(key) => setPersonalizado(key === "personalizado")} style={{ marginBottom: 16 }} tabBarStyle={{ marginBottom: 0 }}>
        <Tabs.TabPane tab="Padrão" key="padrao" />
        <Tabs.TabPane tab="Personalizado" key="personalizado" />
      </Tabs>

      {/* Tabela */}
      <MiniTable
        ref={miniTableRef}
        columns={columns}
        dataSource={dataSource}
        loading={loading}
        title={title}
        rowSelection={
          rowSelectionEnabled
            ? {
                type: "checkbox",
                selectedRowKeys: selectedIds,
                onChange: (selectedRowKeys) => {
                  if (singleSelection) {
                    const lastSelected = selectedRowKeys[selectedRowKeys.length - 1];
                    onSelectedIdsChange([lastSelected]);
                  } else {
                    onSelectedIdsChange(selectedRowKeys);
                  }
                },
              }
            : null
        }
      />
    </div>
  );
}

ModelosTable.propTypes = {
  dataSource: PropTypes.array,
  loading: PropTypes.bool,
  miniTableRef: PropTypes.object,
  onClick: PropTypes.func,
  onSelectedIdsChange: PropTypes.func,
  selectedIds: PropTypes.arrayOf(PropTypes.number),
  title: PropTypes.func,
};
